export interface IMember {
  permitNumber: string;
  firstName: string;
  lastName: string;
}

export class Member implements IMember {
  permitNumber: string;
  firstName: string;
  lastName: string;
  generalPrograms?: string[];
  changeDate?: string;

}
